$(function () {

 
    $(document).on("click", ".save-traveler-button", function (e) {
        e.preventDefault();
        saveTravelerDetail();
    })

    $(document).on("click", ".jq-create-new-traveler", function (e) {
        e.preventDefault();
        showModal({ url: "/widgets/Traveler/Traveler-New.aspx", saveText: "Create New Traveler", title: "Create Traveler", callback: function (modal) {saveTravelerDetail(modal,onNewTravelerDash)}}) ;       
    })

});


function editall_traveler() {
    if ($("#txttravelerFName").val() == "") {
        showSystemNotification('First Name is required')
        $("#txttravelerFName").focus() 
        return false
    }
    
    if ($("#txttravelerLName").val() == "") {
        showSystemNotification('Last Name is required')
        $("#txttravelerLName").focus() 
        return false
    }
            
    if ($("#txttravelerEMailAddress").val() == "") {
        showSystemNotification('Valid Email Address is required')
        $("#txttravelerEMailAddress").focus() 
        return false
    }

    //todo validate email format
    
    return true;
}



function saveTravelerDetail(modal,callback) {
    
    if (editall_traveler()){
        element_Blur ('.save-traveler-button',true)
        var req = new Object;
        req.UserClientId = $('#travelerclientId').val();
        req.EMail = $('#txttravelerEMailAddress').val();
        req.FirstName = $('#txttravelerFName').val();
        req.LastName = $('#txttravelerLName').val();
        req.DisplayName = $('#txttravelerDisplayName').val();
        req.HomePhone = $('#txttravelerHomePhone').val();
        req.WorkPhone = $('#txttravelerWorkPhone').val();
        req.WorkPhoneExt = $('#txttravelerWorkExtension').val();
        req.MobilePhone = $('#txttravelerMobilePhone').val();
        req.BestPhoneCd = $('#seltravelerPreferredPhone').val();
        req.SkypeName = $('#txttravelerSkypeName').val();
        req.AltEmail = $('#txttravelerAltEmail').val();
        req.Address1 = $('#txttravelerAddressLine1').val();
        req.Address2 = $('#txttravelerAddressLine2').val();
        req.ZipCode = $('#txttravelerPostalCode').val();
        req.CityName = $('#txttravelerCity').val();
        req.StatePlaceKey = $('#seltravelerState :selected').val();
        req.CountryPlaceKey = $('#seltravelerCountry').val();
        req.CommentsSpecialNeeds = $('#tatravelerSpecialNeeds').val();
        req.CommentsFamily = $('#tatravelerFamilyInfo').val();
        req.CommentsMisc = $('#tatravelerMisc').val();

        var DTO = { 'Req': req }
        DynaProxy.invoke("SaveTraveler", DTO, function (data) {                   
            element_Blur ('.save-traveler-button',false);
        setEditClean();
            var name=req.FirstName + ' ' + req.LastName;
            if( typeof callback == "function" )  {
                callback(modal,data,name);
            }
            else{
                if (req.UserClientId =="" || req.UserClientId==undefined) {
                    showSystemNotification("New Traveler '" + name + "' has been created"); 
                    refrehTravelerList(false);   
                } else {
                    showSystemNotification("Traveler '" + name + "' has been updated");
                    $(".headline").html(name);
                }
            } 
        }, function (data) {
            element_Blur ('.save-traveler-button',false);        
            showSupportNotification('Unable to save traveler.');
        })
        return true;
    } else {
        return false;
    }

}
      

function do_traveler_delete(cid, cname) {

    if (confirm("Are you sure you want to delete Traveler '" + cname + "'? (this cannot be undone)")) {
        Page_Blur(true);
        DynaProxy.invoke("DeleteTravelers", { Req: cid }, function (data) {
            showSystemNotification("Traveler '" + cname + "' has been deleted.")                       
            if ($(".travelerlist").length > 0) {
                Page_Blur(false);
                refrehTravelerList(false);                         
            } else {        // from traveler detail
                window.location = "/Home";
            }
        }, function (data) {
            Page_Blur(false);
            showSupportNotification("Unable to delete Traveler '" + cname + "'.");
        })                       
    }

}

    
 function onNewTravelerTrip(modal,cid){
    closeModal(modal)                       
    showSystemNotification("New Traveler '" + name + "' has been created. Please select it in the list."); 
    refrehTravelerList(false);   
}


function onNewTravelerDash(modal,cid,name){
    closeModal(modal)                       
    showSystemNotification("New Traveler '" + name + "' has been created"); 
    refrehTravelerList(false);   
}


